
import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getDDJJNuevo } from '../../actions/index'
import { useParams } from "react-router"
import DDJJpic from '../../assets/forms/form2.png'
import AnexoPic from '../../assets/forms/form1.png'

const Renovaciones = () => {
  
  const ddjj = useSelector(state => state.ddjjNuevo)
  const token = localStorage.getItem('token')
  const {userId} = useParams()
  const dispatch = useDispatch()

  
  
  
  useEffect(()=>{
    dispatch(getDDJJNuevo(userId,token))
  }, [])
  

  return (
    
    <div className='w-screen flex flex-col gap-10'>
      {ddjj[0] &&
      <div> 
       <div className='w-full flex items-center justify-center p-12' style={{background: 'rgba(0, 0, 0, 0.3)'}}>
          <span className='text-4xl text-white'> {ddjj[0].nombre.toUpperCase()} {ddjj[0].apellido.toUpperCase()} </span>
       </div>
     
      <div className='p-10'>
        <div className='bg-background_home hover:bg-green-800  rounded flex flex-row gap-2 h-full text-white w-24 p-2 items-center justify-center hover:text-slate-300'>
       <Link to='/adminpanel' className='w-30 h-full'>
          <p>VOLVER</p>
      </Link>
        </div>

        <div className='flex flex-row gap-10 items-center justify-center'>

        <div className='flex flex-col gap-10 border p-6'>
          <img src={DDJJpic} alt="ddjj" width={400} height={400} />
          <Link to={'/completarddjjdocRenovado/'+ userId}>
            <button className='bg-background_home p-2 text-white'>COMPLETAR</button>
          </Link>
        </div>

        <div className='flex flex-col gap-10 border p-6'>
          <img src={AnexoPic} alt="ddjj" width={400} height={400} />
          <Link to={'/completaranexodocRenovado/'+ userId}>
            <button className='bg-background_home p-2 text-white'>COMPLETAR</button>
          </Link>
        </div>
        

        <div className='flex flex-col items-center'>
           <div className='flex flex-row'>
            <span className='border font-bold w-72 p-2'>Fecha de Nacimiento: </span>
            <span className='border w-72 p-2'> {ddjj[0].fechaDeNacimiento} </span>
           </div>          

           <div className='flex flex-row'>
            <span className='border font-bold w-72 p-2'>Email: </span>
            <span className='border w-72 p-2'> {ddjj[0].email} </span>
           </div>            
           
           <div className='flex flex-row'>
            <span className='border font-bold w-72 p-2'>Teléfono particular: </span>
            <span className='border w-72 p-2'> {ddjj[0].telefonoParticular} </span>
           </div>            
           
           <div className='flex flex-row'>
            <span className='border font-bold w-72 p-2'>Teléfono celular: </span>
            <span className='border w-72 p-2'> {ddjj[0].telefonoCelular} </span>
           </div>            
           
           <div className='flex flex-row'>
            <span className='border font-bold w-72 p-2'>DNI: </span>
            <span className='border w-72 p-2'> {ddjj[0].dni} </span>
           </div>            
           
           <div className='flex flex-row'>
            <span className='border font-bold w-72 p-2'>Domicilio: </span>
            <span className='border w-72 p-2'> {ddjj[0].domicilio} </span>
           </div>            
           
           <div className='flex flex-row'>
            <span className='border font-bold w-72 p-2'>Localidad: </span>

            <span className='border w-72 p-2'> {ddjj[0].localidad} </span>
           </div>                       
           <div className='flex flex-row'>
            <span className='border font-bold w-72 p-2'>Obra social: </span>
            <span className='border w-72 p-2'>{ddjj[0].obraSocial}</span>
           </div>           
        </div>
        </div>
        </div>
        </div>
        }
    </div>
  )
}


export default Renovaciones